module.exports = __webpack_public_path__ + "cf40feaf20bab7d07843213e6abdadc9.pdf";